import React, { Component } from 'react';
import jquery from 'jquery';
import { message, Table, Popconfirm, Button } from 'antd';
import API_URL from '../../common/url';
import $ from '../../common/AjaxRequest';
import LeakModal from './LeakCreateModal';
import SearchSelect from '../common/SearchSelect';

class InvContractRelated extends Component {
    state = {
        sortParams: {},
        searchParams: {},
        data: [],
        loading: false,
        addStatus: false,
        pagination: {
            pageSize: 10,
            current: 1,
        },
        dateFormat: "YYYY-MM-DD",
        userOptions: [],
        siteOptions: [],
        dataList: [],
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = (params = {}) => {
        this.setState({ loading: true });
        const { searchParams, pagination } = this.state;
        const options = {
            url: `${API_URL.sumtotal.queryInvestigationFte}`,
            data: {
                offset: pagination.current,
                ...params,
                ...searchParams,
                limit: pagination.pageSize,
            },
            dataType: 'json',
            doneResult: data => {
                const pagination = { ...this.state.pagination };
                pagination.total = data.totalCount;
                this.setState({
                    loading: false,
                    dataList: data.datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const { dataList = [] } = this.state;
        const list = dataList[0] ? dataList[0].fteList : [];
        const columnNames = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
        }, {
            title: '中心编号',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            sorter: true,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            sorter: true,
        }, {
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            sorter: true,
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            sorter: true,
        }, {
            title: '角色',
            dataIndex: 'roleCode',
            key: 'roleCode',
            sorter: false,
        },];
        list && list.map((d, i) => {
            columnNames.push({
                title: d.year + "." + d.month,
                dataIndex: `fteValue${i}`,
                key: `fteValue${i}`,
            });
        })

        columnNames.push({
            title: '操作',
            fixed: "right",
            width: 80,
            render: (text, record) => {
                return (
                    <span>
                        <a onClick={() => { this.edit(record, 'edit') }}>修改</a>
                        <span className="ant-divider" />
                        <Popconfirm title={'确定要删除吗?'} onConfirm={this.del.bind(this, record)} okText="确定" cancelText="取消">
                            <a >删除</a>
                        </Popconfirm>
                    </span>
                );
            },
        });

        return columnNames;

    }

    getDataSource = () => {
        const sites = [];
        const { dataList, pagination, total } = this.state;
        dataList.map((dataItem, i) => {
            const ftelist = {};
            dataItem.fteList.map((d, j) => {
                ftelist[`fteValue${j}`] = d.fte
            });
            sites.push({
                index: ((pagination.current - 1) || 0) * 10 + i + 1,
                ...dataItem,
                ...ftelist,
            });
        });
        return sites;
    };

    handleChange = (e) => {
        const value = e.target.value;
        this.setState({ "keyword": value });
    }

    handleTableChange = (pagination, filters, sorter) => {
        let sortType,
            direction,
            sort = sort = sorter.field;
        const pager = { ...this.state.pagination };
        if (pager.current == pagination.current) {
            pager.current = 1;
            //排序则页码为1
        } else {
            pager.current = pagination.current;
            //获取当前页
        }
        if (!jquery.isEmptyObject(sorter) && sorter.column) {
            sortType = sorter.column.sortType;
        }
        if (sorter.order === 'descend') {
            direction = 'DESC';
        } else {
            direction = 'ASC';
        }
        this.setState({
            pagination: pager,//设置新的分页信息
            sortParams: {//设置排序信息
                direction,
                sort,
                sortType
            }
        });

        this.loadData({
            limit: pager.pageSize,
            offset: pager.current,
            direction,
            sort,
            sortType,
            ...this.state.searchParams,
            ...filters,
        });
    }

    reload = (params = {}, type) => {
        const newParams = {};
        if (type == "search") {
            newParams.searchParams = params;
            newParams.pagination = { ...this.state.pagination, current: 1 };
        }
        this.setState({
            ...newParams
        }, function () {
            const { pagination, searchParams, sortParams } = this.state;
            this.loadData({
                offset: pagination.current,
                ...sortParams,
                ...searchParams,
            });
        })
    }

    search = () => {
        const { searchParams, keyword } = this.state;
        const newSearch = {
            ...searchParams,
            keyword
        };
        this.setState({
            searchParams: newSearch
        }, () => {
            this.reload(newSearch, "search");
        });
    }

    addJde = () => {
        this.ChildJde.show("add");
    }

    edit = (record = {}, mode) => {
        if (record.fteList) {
            const newList = record.fteList.filter(fte => fte.fte != null);
            record.fteList = newList;
        }
        this.createModalRef.show(record, mode);
    }

    del = (record = {}) => {
        const { investigationSiteId, userId, roleCode } = record;
        this.setState({ loading: true });
        const options = {
            url: `${API_URL.sumtotal.deleteInvestigationFte}`,
            data: {
                userId,
                roleCode,
                investigationSiteId,
            },
            dataType: 'json',
            doneResult: () => {
                message.success("删除成功");
                this.setState({ loading: false }, () => {
                    this.reload();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    toggleLeak = () => {
        this.props.toggleLeak(false);
    }

    addRelate = () => {
        this.createModalRef.show({}, "add");
    }

    parserDataSite = (dt, value) => {
        if (!value) {
            const { searchParams } = this.state;
            searchParams.investigationSiteId = '';
            this.setState({ searchParams });
        }
        if ((dt.data || dt.datas)) {
            const sourceData = dt.data ? dt.data.siteList.datas : dt.datas;
            const data = sourceData.map(r => ({
                text: `${r.investigationSiteName}-(${r.investigationSiteCode})`,
                value: r.investigationSiteId,
            }));
            this.setState({ siteOptions: data });
        } else {
            this.setState({ siteOptions: [] });
        }
    }

    siteSelectChanged = (value) => {
        const { searchParams } = this.state;
        searchParams.investigationSiteId = value.key;
        this.setState({ searchParams });
    }

    parserDataUser = (dt, value) => {
        if (!value) {
            const { searchParams } = this.state;
            searchParams.userId = '';
            this.setState({ searchParams });
        }
        if ((dt.data || dt.datas)) {
            const sourceData = dt.data ? dt.data.crcList : dt.datas;
            const data = sourceData.map(r => ({
                text: `${r.userCompellation}[${r.employeeCode}]`,
                value: r.userId,
            }));
            this.setState({ userOptions: data });
        } else {
            this.setState({ userOptions: [] });
        }
    }

    userSelectChanged = (value) => {
        const { searchParams } = this.state;
        searchParams.userId = value.key;
        this.setState({ searchParams });
    }

    render() {
        const { loading, pagination, dataList = [] } = this.state;
        const invId = sessionStorage.invId;
        return (
            <div>
                <div className="filter-bar bar2">
                    <div className="form-item">
                        <label className="ui-label">中心编号/中心名称</label>
                        <SearchSelect
                            style={{ width: 250 }}
                            url={API_URL.site.list}
                            searchKey='searchKey'
                            sourceData={this.state.siteOptions}
                            parserData={this.parserDataSite}
                            handleSelect={this.siteSelectChanged}
                            placeholder={'输入中心名或编号'}
                            allowClear={true}
                            className='manhour-select'
                            searchParam={invId && { invId: invId }}
                        />
                    </div>
                    <div className="form-item">
                        <label className="ui-label">工号/姓名</label>
                        <SearchSelect
                            style={{ width: 110 }}
                            url={API_URL.team.userlist}
                            searchKey='keyword'
                            sourceData={this.state.userOptions}
                            parserData={this.parserDataUser}
                            handleSelect={this.userSelectChanged}
                            placeholder={'输入名字或工号'}
                            allowClear={true}
                            className=''
                        />
                    </div>
                    <div className="btn" style={{ float: 'right' }}>
                        <Button type="primary" style={{ float: 'right' }} onClick={this.toggleLeak}>返回</Button>
                        <Button type="primary" onClick={this.addRelate}>添加</Button>
                        <Button type="primary" onClick={this.search}>搜索</Button>

                    </div>
                </div>
                <Table
                    columns={this.getColumns()}
                    dataSource={this.getDataSource()}
                    rowKey={record => record.index + record.employeeCode}
                    loading={loading}
                    pagination={pagination}
                    onChange={this.handleTableChange}
                    scroll={{ x: dataList[0] && dataList[0].fteList && dataList[0].fteList.length * 90 + 500 }}
                />
                <LeakModal
                    reload={this.reload}
                    ref={el => this.createModalRef = el}
                />
            </div>
        );
    }
}

export default InvContractRelated;


// WEBPACK FOOTER //
// ./src/components/sumTotal/AddLeak.js